import React from 'react';
import PropTypes from 'prop-types';

import PageHeader from 'components/project/page_header';

export default function PeoplePageHeader({ onAddContact }) {
  const actions = (
    <PageHeader.Actions>
      <button
        className="btn btn-create pull-right"
        name="btn-add-contact"
        onClick={(e) => {
          e.preventDefault();
          if (onAddContact) onAddContact();
        }}
      >
        Add Contact
      </button>
    </PageHeader.Actions>
  );

  return (
    <PageHeader actions={actions} title="Contacts" />
  );
}

PeoplePageHeader.propTypes = {
  onAddContact: PropTypes.func
};
